import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CustomerService from "../../rest/customerService";
import TopNavBar from "../../components/reusables/topNavBar";
import { formatCPF, formatPhoneNumber } from "../../utils/DocumentUtils";
import { MdOutlineOpenInNew, MdPerson, MdEmail, MdPhone, MdHome, MdBadge } from "react-icons/md";
import { FaChild } from "react-icons/fa";

function ParentPage() {
    const login = sessionStorage.getItem("login");
    const [client, setClient] = useState(null);
    const [parenting, setParenting] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const clientData = await CustomerService.getSpecificParent(login);
                setClient(clientData);
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, [login]);

    useEffect(() => {
        if (client && client.login) {
            const fetchClientDetails = async () => {
                try {
                    const parentingData = await CustomerService.findStudentsByParent(login);
                    setParenting(parentingData);
                } catch (error) {
                    console.error(error);
                }
            };
            fetchClientDetails();
        }
    }, [client, login]);

    const DataField = ({ label, value, icon: Icon }) => (
        <div className="flex flex-col mb-4">
            <div className="flex items-center gap-2 mb-1 text-sm font-semibold text-gray-500 uppercase tracking-wider">
                {Icon && <Icon className="text-custom_blue" />}
                {label}
            </div>
            <div className="text-gray-800 font-medium text-lg border-b border-gray-200 pb-1">
                {value || "Não informado"}
            </div>
        </div>
    );

    return (
        <div className='h-screen flex flex-col bg-slate-50'>
            <TopNavBar title="Cadastro" />

            <div className='flex-1 overflow-y-auto p-4 md:p-8'>
                {client ? (
                    <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6">
                        <div className="lg:col-span-2 space-y-6">
                            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
                                <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                                    <MdPerson className="text-custom_blue" size={24} />
                                    Informações Pessoais
                                </h2>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <DataField label="Nome Completo" value={client.name} icon={MdPerson} />
                                    <DataField label="CPF" value={formatCPF(client.cpf)} icon={MdBadge} />
                                    <DataField label="Email" value={client.email} icon={MdEmail} />
                                    <DataField label="Telefone" value={formatPhoneNumber(client.phone_number)} icon={MdPhone} />
                                    <div className="md:col-span-2">
                                        <DataField label="Endereço" value={client.address} icon={MdHome} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="lg:col-span-1">
                            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 h-full">
                                <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                                    <FaChild className="text-custom_blue" size={20} />
                                    Alunos Vinculados
                                </h2>

                                {parenting.length > 0 ? (
                                    <div className="space-y-3">
                                        {parenting.map((s, index) => (
                                            <div key={index} className="flex items-center justify-between p-4 rounded-xl border border-slate-100 bg-slate-50 hover:border-custom_blue/30 transition-colors group">
                                                <div>
                                                    <p className="font-bold text-gray-800">{s.name}</p>
                                                    <p className="text-sm text-gray-500">{s.grade}</p>
                                                </div>
                                                <Link to={`/clientes/detalhesCliente/${s.login}`}>
                                                    <button className="p-2 rounded-full bg-white text-custom_blue shadow-sm group-hover:bg-custom_blue group-hover:text-white transition-all">
                                                        <MdOutlineOpenInNew size={20} />
                                                    </button>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-center py-10 text-gray-400 bg-slate-50 rounded-xl border border-dashed border-slate-200">
                                        <p>Nenhum aluno vinculado.</p>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                ) : (
                    <div className="flex items-center justify-center h-full text-gray-500">
                        <p>Carregando informações ou cadastro não encontrado.</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ParentPage;